class BitebackProductCard extends HTMLElement {
  connectedCallback() {
    this.variantInput = this.querySelector('[data-bb-product-card-variant-input]');
    this.priceTarget = this.querySelector('[data-bb-product-card-price]');
    this.optionLabel = this.querySelector('[data-bb-product-card-option-label]');
    this.submitButton = this.querySelector('[name="add"]');
    this.chips = Array.from(this.querySelectorAll('[data-bb-product-card-variant-chip]'));

    this.chips.forEach((chip) => {
      chip.addEventListener('click', () => this.selectVariant(chip));
    });
  }

  selectVariant(chip) {
    if (!this.variantInput || chip.disabled || chip.dataset.variantAvailable !== 'true') return;

    this.chips.forEach((item) => {
      const isSelected = item === chip;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    this.variantInput.value = chip.dataset.variantId;
    this.variantInput.disabled = false;

    if (this.priceTarget && chip.dataset.variantPrice) {
      this.priceTarget.textContent = chip.dataset.variantPrice;
    }

    if (this.optionLabel && chip.dataset.variantTitle) {
      this.optionLabel.textContent = chip.dataset.variantTitle;
    }

    if (this.submitButton) {
      const buttonText = this.submitButton.querySelector('span');
      this.submitButton.disabled = false;
      this.submitButton.removeAttribute('aria-disabled');
      if (buttonText) {
        buttonText.textContent = this.classList.contains('bb-product-card--range-commerce') ? 'Add to cart' : 'Add to Basket';
      }
    }
  }
}

if (!customElements.get('biteback-product-card')) {
  customElements.define('biteback-product-card', BitebackProductCard);
}
